import { SelectOption } from '../Select'
import { CypressSelectable } from '../../../types'

export interface SelectMultiCheckboxProps extends CypressSelectable {
  id: string
  className?: string
  title?: string
  value: SelectOption['value'][]
  options: SelectOption[]
  onChange: (selected: SelectOption['value'][]) => void
  closeOnSelect?: boolean
  selectAllOption?: boolean
  menuPlacement?: MenuPlacement
  disabled?: boolean
  help?: string
  onMenuClose?: () => void
  onMenuOpen?: () => void
  // a menu opened inside a scrolled box is cut off by it, portalling takes it out of the box
  menuPortalTarget?: HTMLElement | null
  // what the closed select reads when nothing is picked, 'all' unless a caller says otherwise
  allLabel?: string
}

export enum MenuPlacement {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
